/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fresh_Rosy_Newt_PushInputs */

const en_fresh_rosy_newt_push = /** @type {(inputs: Fresh_Rosy_Newt_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Results are still being computed`)
};

const de_fresh_rosy_newt_push = /** @type {(inputs: Fresh_Rosy_Newt_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnisse werden noch berechnet`)
};

/**
* | output |
* | --- |
* | "Results are still being computed" |
*
* @param {Fresh_Rosy_Newt_PushInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fresh_rosy_newt_push = /** @type {((inputs?: Fresh_Rosy_Newt_PushInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fresh_Rosy_Newt_PushInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fresh_rosy_newt_push(inputs)
	return de_fresh_rosy_newt_push(inputs)
});